import React, { useState } from 'react';
import { Check } from 'lucide-react';
export const PricingSection = () => {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'aquelarre'>('aquelarre');
  const baseLink = 'https://checkout.totaliadigital.com/cart/53549604733296:1';
  const aquelarreLink = 'https://checkout.totaliadigital.com/cart/53549633798512:1';
  return <section id="pricing" className="py-20 px-4 relative z-10 scroll-mt-20" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <div className="text-center mb-12" data-id="element-128">
          <h2 className="font-cormorant text-4xl md:text-5xl text-text-primary mb-4" data-id="element-129">
            Elegí el plan que mejor se ajuste a tu camino
          </h2>
        </div>

        {/* Plan Toggle */}
        <div className="flex justify-center gap-2 mb-10 max-w-md mx-auto" data-id="element-130">
          <button onClick={() => setSelectedPlan('base')} className={`flex-1 py-3 px-4 rounded-full text-sm font-medium tracking-wide transition-all duration-300 border ${selectedPlan === 'base' ? 'bg-gold-primary/20 border-gold-light text-gold-light shadow-[0_0_15px_rgba(201,165,78,0.15)]' : 'border-gold-dark/30 text-text-muted hover:border-gold-dark/60 hover:text-text-soft'}`} data-id="element-131">
            <span className="flex items-center justify-center gap-2" data-id="element-132">
              <span className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${selectedPlan === 'base' ? 'border-gold-light bg-gold-light' : 'border-text-muted'}`} data-id="element-133" />
              Grimorio
            </span>
          </button>
          <button onClick={() => setSelectedPlan('aquelarre')} className={`flex-1 py-3 px-4 rounded-full text-sm font-medium tracking-wide transition-all duration-300 border ${selectedPlan === 'aquelarre' ? 'bg-gold-primary/20 border-gold-light text-gold-light shadow-[0_0_15px_rgba(201,165,78,0.15)]' : 'border-gold-dark/30 text-text-muted hover:border-gold-dark/60 hover:text-text-soft'}`} data-id="element-134">
            <span className="flex items-center justify-center gap-2" data-id="element-135">
              <span className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${selectedPlan === 'aquelarre' ? 'border-gold-light bg-gold-light' : 'border-text-muted'}`} data-id="element-136" />
              Aquelarre ⭐
            </span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12" data-id="element-137">
          {/* Base Plan */}
          <div onClick={() => setSelectedPlan('base')} className={`cursor-pointer rounded-2xl p-6 md:p-8 transition-all duration-300 border-2 ${selectedPlan === 'base' ? 'border-gold-light surface-gradient shadow-[0_0_30px_rgba(201,165,78,0.15)] scale-[1.02]' : 'border-gold-dark/20 bg-mystic-surface/50 hover:border-gold-dark/50'}`} data-id="element-138">
            <div className="text-center mb-6 border-b border-gold-dark/20 pb-6" data-id="element-139">
              <h3 className="font-cormorant text-2xl text-gold-light mb-2" data-id="element-140">
                ☽ GRIMORIO DEL SUR ☾
              </h3>
              <p className="text-text-soft text-sm" data-id="element-141">El inicio de tu camino</p>
            </div>

            <div className="mb-8" data-id="element-142">
              <p className="text-text-muted line-through text-center text-lg mb-1" data-id="element-143">
                $37.900 ARS
              </p>
              <div className="text-center mb-2" data-id="element-144">
                <span className="text-4xl font-bold text-text-primary" data-id="element-145">
                  $18.790
                </span>
              </div>
              <p className="text-gold-light text-center text-sm font-medium" data-id="element-146">
                Hasta 3 cuotas fijas sin interés
              </p>
            </div>

            <ul className="space-y-4 mb-8" data-id="element-147">
              <li className="flex items-start gap-3" data-id="element-148">
                <Check className="w-5 h-5 text-gold-primary shrink-0" data-id="element-149" />
                <span className="text-text-primary font-medium" data-id="element-150">
                  📖 Tomo Principal — Mi Primer Grimorio (120+ páginas)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-151">
                <Check className="w-5 h-5 text-gold-primary shrink-0" data-id="element-152" />
                <span className="text-text-soft" data-id="element-153">
                  🌙 Bonus 1: Diario de Espiritualidad
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-154">
                <Check className="w-5 h-5 text-gold-primary shrink-0" data-id="element-155" />
                <span className="text-text-soft" data-id="element-156">
                  🔮 Bonus 2: Predicciones del Zodíaco 2026
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-157">
                <Check className="w-5 h-5 text-gold-primary shrink-0" data-id="element-158" />
                <span className="text-text-soft" data-id="element-159">
                  📅 Bonus 3: Planificador Lunar
                </span>
              </li>
            </ul>
          </div>

          {/* Aquelarre Plan */}
          <div onClick={() => setSelectedPlan('aquelarre')} className={`cursor-pointer rounded-2xl p-6 md:p-8 transition-all duration-300 border-2 relative ${selectedPlan === 'aquelarre' ? 'border-gold-primary surface-gradient shadow-[0_0_40px_rgba(201,165,78,0.2)] scale-[1.05] z-10' : 'border-gold-dark/30 bg-mystic-surface/80 hover:border-gold-dark/60'}`} data-id="element-160">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-primary text-mystic-bg px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider whitespace-nowrap" data-id="element-161">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-center mb-6 border-b border-gold-dark/20 pb-6 mt-2" data-id="element-162">
              <h3 className="font-cormorant text-2xl text-gold-light mb-2" data-id="element-163">
                ☽ EL AQUELARRE COMPLETO ☾
              </h3>
              <p className="text-text-soft text-sm" data-id="element-164">
                Todo el grimorio + 8 bonus extra
              </p>
            </div>

            <div className="mb-8" data-id="element-165">
              <p className="text-text-muted line-through text-center text-lg mb-1" data-id="element-166">
                $57.900 ARS
              </p>
              <div className="text-center mb-2" data-id="element-167">
                <span className="text-5xl font-bold text-gold-light" data-id="element-168">
                  $27.990
                </span>
              </div>
              <p className="text-gold-primary text-center text-sm font-bold mb-1" data-id="element-169">
                Ahorrás $29.910
              </p>
              <p className="text-text-primary text-center text-sm" data-id="element-170">
                Hasta 3 cuotas fijas sin interés
              </p>
            </div>

            <ul className="space-y-3 mb-8 text-sm" data-id="element-171">
              <li className="flex items-start gap-3" data-id="element-172">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-173" />
                <span className="text-text-primary font-medium" data-id="element-174">
                  Todo lo del Grimorio del Sur +
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-175">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-176" />
                <span className="text-text-soft" data-id="element-177">🌑 Diario de Bruja 2026</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-178">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-179" />
                <span className="text-text-soft" data-id="element-180">
                  ✨ Manifestaciones Espirituales
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-181">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-182" />
                <span className="text-text-soft" data-id="element-183">
                  📓 Diario de Manifestación
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-184">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-185" />
                <span className="text-text-soft" data-id="element-186">
                  💰 Manual de Abundancia y Riqueza
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-187">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-188" />
                <span className="text-text-soft" data-id="element-189">
                  🧘 Planificador de Chakras
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-190">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-191" />
                <span className="text-text-soft" data-id="element-192">
                  🧹 Planificador de Brujas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-193">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-194" />
                <span className="text-text-soft" data-id="element-195">💎 Guía de Cristales</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-196">
                <Check className="w-4 h-4 text-gold-primary shrink-0 mt-0.5" data-id="element-197" />
                <span className="text-text-soft" data-id="element-198">
                  🌿 Diario de Hierbas y Aceites Esenciales
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center max-w-md mx-auto" data-id="element-199">
          <a href={selectedPlan === 'aquelarre' ? aquelarreLink : baseLink} className="btn-gold block w-full px-8 py-5 rounded-full text-xl font-bold uppercase tracking-wide shadow-[0_0_30px_rgba(201,165,78,0.3)] mb-4" data-id="element-200">
            {selectedPlan === 'aquelarre' ? 'QUIERO EL AQUELARRE COMPLETO' : 'QUIERO EL GRIMORIO'}
          </a>
          <p className="text-text-muted text-sm flex items-center justify-center gap-2" data-id="element-201">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-202"></span>
            Oferta por tiempo limitado — vence cuando termina el contador
          </p>
        </div>
      </div>
    </section>;
};